/*eslint-disable*/
/*
 Attaches input mask onto input element
 */

angular.module('kareo.ui.shared.directives.ui-mask', ['ui.mask']);
